import React from 'react';
import {Text} from 'react-native';

import {Code, FlexView, Heading, Spacer} from '/component/base/Storybook';

import Checkbox from '../Checkbox';

export default () => (
  <>
    <Heading level={1}>ReadOnly State</Heading>
    <Spacer size={16} />
    <Text>
      The read-only state of the <Code>Checkbox</Code> component is controlled
      via the <Code>readonly</Code> prop.
    </Text>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center" expand={false}>
        <Checkbox checked={true} readonly={false} />
        <Spacer size={6} />
        <Code>{'readonly={false}'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center" expand={false}>
        <Checkbox checked={true} readonly={true} />
        <Spacer size={6} />
        <Code>{'readonly={true}'}</Code>
      </FlexView>
    </FlexView>
  </>
);
